import React, {useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import Analytics from '../../../analytics';
import {userLogin} from "../../../api/user-api";
import MaterialSpinner from "../../ui/materialSpinner";
import {saveQuote} from "../../../api/server-api";
import {showQuoteSavedNotification} from "../../ui/successNotification";
import {COLORS} from "../../../colorThemes";

const LookLoginButton = (props) => {

  const {popupClose} = props;
  const [isLoading, setIsLoading] = useState(false);

  const loginButtonClick = async () => {
    setIsLoading(true);
    Analytics.sendClickEvent("user-popup-submit-login");
    const userLogined = await userLogin();
    if (userLogined) {
      const save = await saveQuote({submit: true, showReceipt: false})
      if (save) {
        showQuoteSavedNotification();
        popupClose();
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }

  return (
    <Button className={"look-button look-button--primary look-button--big look-button--large ll-user__submit"}
            endIcon={<ChevronRightIcon />}
            disabled={isLoading}
            // loading={isLoading}
            // loadingPosition="end"
            onClick={loginButtonClick}>
      <FormattedMessage id="look.login.submitButton"/>
      {isLoading ? <MaterialSpinner color={COLORS.white}/> : null}
    </Button>
  )
};

const mapStateToProps = () => {
  return {};
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(LookLoginButton)
